import { render } from "./MerchThanks.vue?vue&type=template&id=14cc69e3&scoped=true"
import script from "./MerchThanks.vue?vue&type=script&lang=js"
export * from "./MerchThanks.vue?vue&type=script&lang=js"

import "./MerchThanks.vue?vue&type=style&index=0&id=14cc69e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14cc69e3"]])

export default __exports__